import sectionIconWithTextB1Css from '../css-snippets/section-icon-with-text-b1';

const html = `
<style>${sectionIconWithTextB1Css}</style>
<div class="wrapper-container" id="" data-id="" data-attribute="wrapper-container" data-background-color="#355052"
  data-enable-background-image="false" data-background="#ffffff" data-top-padding="true" data-bottom-padding="true"
  data-text-color="#ffffff"
  style="--text-color: #ffffff; color: rgb(255, 255, 255); background-color: rgb(53, 80, 82);">

  <div class="container">
    <div class="wrap-content">
      <div data-show-header="true" data-attribute="title-content" class="title-content" style="">
        <h3 style="text-align:center;">Not All Outdoor Lights Are Created Equal</h3>
        <p style="text-align:center;">Lorem ipsum dolor sit amet consectetur adipisicing elit. Deleniti voluptatum ipsum
          pariatur.</p>
      </div>

      <div data-with-icon="60" data-align-items="center" data-col-per-view="4" data-attribute="list-item"
        class="wrap-items" style="--col-per-view: 4; --with-icon: 60px; --align-items: center;">
        <div data-attribute="item" class="item-w-t">
          <div data-attribute="image-item" class="wrap-img">
            <img
              src="https://cdn.skyfastimg.com/images/2025/12/25/image-694cbe66326abcadd1312eb2.png?w=200"
              alt="">
          </div>
          <div data-attribute="text-item" class="wrap-text">
            <h2 style="text-align:center;">All-night runtime</h2>
            <p style="text-align:center;">Lorem ipsum dolor sit amet consectetur adipisicing elit</p>
          </div>
        </div>

        <div data-attribute="item" class="item-w-t">
          <div data-attribute="image-item" class="wrap-img">
            <img
              src="https://cdn.skyfastimg.com/images/2025/12/25/image-694cbe9cdc1d628b9b29178e.png?w=200"
              alt="">
          </div>
          <div data-attribute="text-item" class="wrap-text">
            <h2 style="text-align:center;">All-night runtime</h2>
            <p style="text-align:center;">Lorem ipsum dolor sit amet consectetur adipisicing elit</p>
          </div>
        </div>

        <div data-attribute="item" class="item-w-t">
          <div data-attribute="image-item" class="wrap-img">
            <img
              src="https://cdn.skyfastimg.com/images/2025/12/25/image-694cbeaff4bcf2963a3129ea.png?w=200"
              alt="">
          </div>
          <div data-attribute="text-item" class="wrap-text">
            <h2 style="text-align:center;">All-night runtime</h2>
            <p style="text-align:center;">Lorem ipsum dolor sit amet consectetur adipisicing elit</p>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
`;
export default html;
